import DatePicker from 'emerald-ui/lib/DatePicker';
import populateDocs from './utils/populateDocs';

let zIndex = 1000;

function getZIndex() {
  zIndex -= 1;
  return zIndex;
}

export default {
  ...populateDocs([{ component: DatePicker, componentName: 'DatePicker' }], 'DatePicker'),
  description:
    'Lets you choose a date via typing or with a graphical calendar. It supports date ranges (using two Datepicker components), date range disabling and keyboard navigation.',
  codeSamples: [
    {
      title: 'Default',
      scope: { DatePicker },
      whiteBackground: true,
      style: { zIndex: getZIndex() },
      code: `<div>
  <DatePicker ariaLabel="Initial date" />
</div>`,
    },
  ],
};
